import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/UserContext";
import { IconLogout, IconUser } from "../../icons";
import { Button, Container, Divider } from "./styles";
import { comum } from "../../../styles/Themes/light";

interface MenuProps {
    menuSidebar?: boolean,
}

export default function ProfileMenu({menuSidebar}: MenuProps) {

    const { user, signOut } = useAuth();
    const history = useHistory();

    function handleOnLogout() {
        signOut()
        history.push('/login');
    }

    function refreshPage() {
        setTimeout(() => {
            window.location.reload();
        }, 300);
    }

    return (
        <Container menuSidebar={menuSidebar}>
            <Button
                onClick={handleOnLogout}
            >
                <IconLogout color={user?.profile !== 'comum'
                    ? comum.colors.primaryRed400
                    : comum.colors.interfaceGray700} />
                Sair
            </Button>

            <Divider />           

            {   user.profile !== 'comum' && user.profile !== 'Solicitante' &&
                <Link
                    to={`/operadores/` + user.id}
                    onClick={refreshPage}
                >
                    <Button>
                        <IconUser color={user?.profile !== 'comum'
                            ? comum.colors.primaryRed400
                            : comum.colors.interfaceGray700} />
                        Meu Perfil
                    </Button>
                </Link>
            }

            {   user.profile === 'comum' &&
                <Button
                    onClick={() => history.push(`/profissionais/`+ user.id)}
                >
                    <IconUser color={user?.profile !== 'comum'
                        ? comum.colors.primaryRed400
                        : comum.colors.interfaceGray700} />
                    Meu Perfil
                </Button>
            }

            {   user.profile === 'Solicitante' &&
                <Button
                    onClick={() => history.push(`/solicitantes/`+ user.id)}
                >
                    <IconUser color={comum.colors.primaryRed400}
                         />
                    Meu Perfil
                </Button>
            }
        </Container>
    );
}